// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"52590ec5","390":"6ca34aa4","433":"22e04d97","725":"ea537f3d","758":"b7669e60","839":"c5611d40"}[chunkId] + ".chunk.js";
};